var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{},[_c('CCol',{attrs:{"sm":_vm.firstColSm,"lg":"3"}},[_c('label',[_vm._t("firstColContent")],2)]),_c('CCol',{attrs:{"sm":_vm.secondColSm,"lg":"4"}},[_vm._t("secondColContent")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }